var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{class:'footer'},[_c('div',{class:'container'},[_c('nav'),_c('div',{class:'copyright text-center'},[_vm._v("\n      © "+_vm._s(new Date().getFullYear())+" "),_c('b',[_vm._v("PwC")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }